export default "__VITE_ASSET__CWSa7X0v__"